module.exports = __webpack_public_path__ + "img/7.6a6433a7.jpeg";